import { mutationTypes } from './types';

const mutations = {
  [mutationTypes.SET_APPLICATION](state, payload) {
    state.catalog = {
      ...state.catalog,
      application: payload,
    };
  },
  [mutationTypes.SET_LOCATION](state, payload) {
    state.catalog = {
      ...state.catalog,
      location: payload,
    };
  },
  [mutationTypes.SET_ROL](state, payload) {
    state.catalog = {
      ...state.catalog,
      rol: payload,
    };
  },
  [mutationTypes.SET_CURRENT_FILTER](state, payload) {
    state.currentFilter = payload;
  },
  [mutationTypes.SET_FILTER](state, payload) {
    state.filter = payload;
  },
  [mutationTypes.SET_RESULT](state, payload) {
    state.result = {
      ...state.result,
      data: payload.data.map((item) => ({ ...item, isDetailsOpened: false })),
      tableConfig: {
        ...state.result.tableConfig,
        totalRecords: payload.totalItemCount,
        serverParams: {
          ...state.result.tableConfig.serverParams,
          page: payload.currentPage,
        },
      },
    };
  },
  [mutationTypes.SET_MESSAGE_ITEM_COLLAPSE](state, { id }) {
    state.result = {
      ...state.result,
      data: state.result.data.map((item) => {
        item.isDetailsOpened = false;
        if (item.messageId === id) {
          item.isDetailsOpened = true;
        }
        return item;
      }),
    };
  },
};

export default mutations;
